import React, {Component} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import '../assets/css/result.css';
import ReactGA from 'react-ga';
import axios from 'axios';
import {result_set} from '../assets/story_set'
import {IMG_URL, ADDY_URL} from "../config";
import Ads from "./Ads";

class Result extends Component {
    state = {
        result: result_set[this.props.match.params.id],
        is_like: false,
        per: 0,
        like: 0,
        id: this.props.match.params.id
    };


    async componentDidMount() {
        if (this.props.history.action === 'PUSH') {
            await ReactGA.pageview('/mask/result/' + this.props.match.params.id);
            setTimeout(() => {
                ReactGA.event({
                    category: "Story-2 [가면테스트]",
                    action: "Result",
                    label: this.state.result.title
                });
            }, 500)
            axios.get(
                ADDY_URL + '/api/v1/story/mask/' + this.state.id,
                {
                    headers: {
                        'Authorization': "story_add_campus_312523"
                    }
                }).then(({data: {data}}) => {
                this.setState({
                    per: data.per,
                    like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                })
            });
        } else {
            this.props.history.push('/')
        }
    }

    saveImage(url) {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Save",
            label: this.state.result.title
        });
        fetch('https://story.addcampus.com' + url)
            .then((img) => img.blob())
            .then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = url;
                link.download = this.state.result.title + '.jpg';
                link.click();
            })
    }

    copyAlert(url) {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Share",
            label: this.state.result.title
        });
        if (navigator.share) {
            navigator.share({
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        } else {
            alert('복사 되었습니다.');
        }
    }

    async likeBtn() {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Like",
            label: this.state.result.title
        });

        axios.post(
            ADDY_URL + '/api/v1/story/mask/' + this.state.id,
            {},
            {
                headers: {
                    'Authorization': "story_add_campus_312523"
                }
            }).then(({data: {data}}) => {
            this.setState({
                is_like: true,
                like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            })
        })
    }

    replay() {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Replay",
            label: this.state.result.title
        });
        this.props.history.push('/')
    }

    goBanner(banner_type) {
        if (banner_type === 'jungle') {
            ReactGA.event({
                category: "Story-2 [가면테스트]",
                action: "Banner",
                label: "Jungle"
            });
            window.open("https://story.addcampus.com/jungle");
        } else {
            ReactGA.event({
                category: "Story-2 [가면테스트]",
                action: "Banner",
                label: "Addcampus"
            });
            window.open("https://www.addcampus.com");
        }
    }


    render() {
        const {result, is_like, per, like} = this.state;
        let like_btn =
            <div className="result_heart_btn" onClick={() => this.likeBtn()}>
                <div className="heart_div">
                    <img alt="icon" className="icon"
                         src={IMG_URL + '/story/story_2/result/heart.svg'}/>
                </div>
                <p className="heart_text">{like}명이<br/>테스트를 좋아해요!</p>
            </div>;
        if (is_like) {
            like_btn =
                <div className="result_heart_btn">
                    <div className="heart_active_div">
                        <img alt="icon" className="icon"
                             src={IMG_URL + '/story/story_2/result/heart.svg'}/>
                    </div>
                    <p className="heart_text">고마워요!<br/>테스트를 좋아해줘서</p>
                </div>;
        }
        return (
            <div className="result">
                <div className="result_bg" style={{maxWidth: "100%", overflow: "hidden"}}>
                    <img alt="effect" className="light_body_4"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_body.png"/>
                    <img alt="effect" className="light_fire_4"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_fire.png"/>
                    <img alt="effect" className="light_body_5"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_body.png"/>
                    <img alt="effect" className="light_fire_5"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_fire.png"/>
                    <div className="main_wrapper">
                        <div className="result_opacity_div">
                            <p className="result_title" style={{color: result.main_color}}>{result.title}</p>
                            <p className="result_info">*본 검사는 관계의 지속성 관련 문항으로 구성되었으며,<br/>이를 바탕으로 도출했습니다.</p>
                            <div className="result_img_div" style={{background: result.main_color}}><img
                                alt="result_img" className="result_img"
                                src={IMG_URL + result.img_url}/></div>
                            <CopyToClipboard text="https://story.addcampus.com/mask"
                                             onCopy={() => this.copyAlert("https://story.addcampus.com/mask")}>
                                <div className="result_btn_left_div">
                                    <div className="result_share_btn">
                                        <img alt="icon" className="icon"
                                             src={IMG_URL + '/story/story_1/icon/share-icon-white.svg'}/>
                                        <p className="text">URL 복사하기</p>
                                    </div>
                                </div>
                            </CopyToClipboard>
                            <div className="result_btn_right_div">
                                <div className="result_share_btn" style={{border: "none"}}>
                                    <img alt="icon" className="icon" onClick={() => this.saveImage(result.down_img_url)}
                                         src={IMG_URL + '/story/story_2/result/down_icon.svg'}/>
                                    <p className="text" onClick={() => this.saveImage(result.down_img_url)}
                                       style={{verticalAlign: "bottom"}}>이미지 저장하기</p>
                                </div>
                            </div>
                        </div>
                        {
                            result.desc_set ? result.desc_set.map((item, index) => {
                                let per_compo, banner;
                                if (index === 0) {
                                    per_compo =
                                        <p className="result_desc" style={{color: result.main_color}}>{per.toFixed(2)}%
                                            가 {result.title} 이래요!</p>;
                                }
                                if (index === 1) {
                                    banner = <div key={10} className="banner_div" style={{marginTop: "24px"}}
                                                  onClick={() => this.goBanner('addcampus')}>
                                        <img alt="banner" style={{width: '100%', borderRadius: "20px"}}
                                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/result/addcampus_banner.jpg"/>
                                    </div>;
                                }
                                return (
                                    <div key={index}>
                                        {banner}
                                        <div className="result_opacity_div" style={{textAlign: 'left'}}>
                                            <p className="result_desc_title">{item.title}</p>
                                            {per_compo}
                                            <p className="result_desc">{item.desc}</p>
                                        </div>
                                    </div>
                                )
                            }) : null
                        }
                        <Ads style={{marginTop: "18px"}}/>
                        <div className="result_opacity_half_div" style={{width: "48%", float: "left"}}>
                            <div className="result_opacity_div">
                                <p className="result_desc_title">Good<br/>With</p>
                                <p className="result_desc"
                                   style={{color: result_set[result.best].main_color}}>{result_set[parseInt(result.best)].title}</p>
                                <div className="result_friend_img_div"
                                     style={{background: result_set[result.best].main_color}}
                                ><img alt="result_friend_img"
                                      className="result_friend_img"
                                      src={IMG_URL + result_set[parseInt(result.best)].img_url}/>
                                </div>
                            </div>
                        </div>
                        <div className="result_opacity_half_div" style={{width: "48%", float: "right"}}>
                            <div className="result_opacity_div">
                                <p className="result_desc_title">Worst<br/>With</p>
                                <p className="result_desc"
                                   style={{color: result_set[result.worst].main_color}}>{result_set[result.worst].title}</p>
                                <div className="result_friend_img_div"
                                     style={{background: result_set[result.worst].main_color}}>
                                    <img alt="result_friend_img"
                                         className="result_friend_img"
                                         src={IMG_URL + result_set[result.worst].img_url}/>
                                </div>
                            </div>
                        </div>
                        <div className="result_bottom_btn_left_div">
                            {like_btn}
                        </div>
                        <div className="result_bottom_btn_right_div">
                            <div className="result_replay_btn">
                                <img alt="icon" className="icon"
                                     src={IMG_URL + '/story/story_1/icon/replay.svg'}/>
                                <p className="text" onClick={() => this.replay()}>다시 해보기</p>
                            </div>
                        </div>
                        <div className="banner_div" style={{marginTop: "60px"}}
                             onClick={() => this.goBanner('jungle')}>
                            <img alt="banner" style={{width: '100%', borderRadius: "20px"}}
                                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/result/jungle_banner.jpg"/>
                        </div>

                        <div className="footer" style={{margin: "60px 0 30px 0"}}>
                            <p className="copyright">2020 Copyright @ TENDOM. All rights reserved.</p>
                            <a href="mailto:info@tendom.co.kr" className="copyright">Contact Us</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Result;
